
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';

import ChecklistOutlinedIcon from '@mui/icons-material/ChecklistOutlined';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import UpdateOutlinedIcon from '@mui/icons-material/UpdateOutlined';
import CalendarViewWeekOutlinedIcon from '@mui/icons-material/CalendarViewWeekOutlined';
import InputIcon from '@mui/icons-material/Input';

export const settingsWarehousePickingStreamsConfig = {
    all:  {
        title: "all_streams",
        // subTitle: "all_streams_description",
        // subTitle: "All stream registrations",
        icon: <Inventory2OutlinedIcon/>,
        isSingleDataGrid: true,
    },
    
};
